<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import NavBar from '@/components/layout/NavBar.vue'
import OrganizerLoginForm from '@/components/organizer/auth/OrganizerLoginForm.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import type { User } from '@/types/auth'

const route = useRoute()
const router = useRouter()

function onLoginSuccess(_user: User): void {
  const redirect = route.query['redirect']
  if (typeof redirect === 'string' && redirect.startsWith('/')) {
    void router.push(redirect)
  } else {
    void router.push('/organizer/dashboard')
  }
}
</script>

<template>
  <div class="min-h-screen bg-slate-900 flex flex-col">
    <NavBar />
    <div class="flex-1 flex items-center justify-center px-4 py-12">
      <div class="w-full max-w-md">
        <!-- Login card -->
        <div class="bg-slate-800/50 border border-slate-700 rounded-2xl p-8">
          <OrganizerLoginForm @login-success="onLoginSuccess" />
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
